export class MicroappBuildingFilter{
    general: string;
    rol: string;
    host: string;
}